import produce from 'immer';

import {
  CLEAR_VIOLATION_ENTITIES,
  FETCH_ENTITY_LIST_FAILURE,
  FETCH_ENTITY_LIST_SUCCESS,
  LOAD_MORE_ENTITIES,
  LOAD_MORE_VIOLATION_ENTITIES,
  SEARCH_VIOLATION_ENTITY_FAILURE,
  SEARCH_VIOLATION_ENTITY_REQUEST,
  SEARCH_VIOLATION_ENTITY_SUCCESS,
} from '@actions/violationEntity';

const initialState: IViolationEntityStore = {
  searchResults: {
    data: [],
    total: 0,
  },
  isFetching: false,
  error: null,
  entityList: null,
};

export default (state: IViolationEntityStore = initialState, action: any) =>
  produce(state, (draftState: IViolationEntityStore) => {
    switch (action.type) {
      case SEARCH_VIOLATION_ENTITY_REQUEST:
        draftState.isFetching = true;

        return;

      case SEARCH_VIOLATION_ENTITY_SUCCESS:
        draftState.searchResults = action.response;
        draftState.error = null;
        draftState.isFetching = false;

        return;
      case LOAD_MORE_VIOLATION_ENTITIES:
        const { data, total } = action.response;
        draftState.searchResults.total = total;
        draftState.searchResults.data = draftState.searchResults.data.concat(data);
        draftState.error = null;
        draftState.isFetching = false;

        return;

      case SEARCH_VIOLATION_ENTITY_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;
        draftState.searchResults = {
          data: [],
          total: 0,
        };

        return;

      case CLEAR_VIOLATION_ENTITIES:
        draftState.searchResults = {
          data: [],
          total: 0,
        };

        return;

      case FETCH_ENTITY_LIST_SUCCESS:
        draftState.entityList = action.response;
        draftState.error = null;
        draftState.isFetching = false;

        return;
      case LOAD_MORE_ENTITIES:
        const { data: entityListData } = action.response;
        draftState.entityList.data = draftState.entityList.data.concat(entityListData);
        draftState.error = null;

        return;
      case FETCH_ENTITY_LIST_FAILURE:
        draftState.isFetching = false;
        draftState.entityList = null;
        draftState.error = action.error;

        return;
    }
  });
